import Vue from 'vue'
import App from './App.vue'
import Vue2ScaleBox from 'vue2-scale-box'
import focusable from 'vue-tv-focusable'
import router from './router';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'; 
Vue.use(VueAwesomeSwiper);
Vue.use(focusable)
Vue.use(Vue2ScaleBox, {
  width: 1920,   
  height: 1080,  
  autoScale: true 
})
Vue.config.productionTip = false
// 可选：全局配置焦点样式
Vue.prototype.$tv.init({
  focusClassName: 'tv-focus', // 焦点元素的 CSS 类名
  KEYS: { // 自定义遥控器按键映射
    KEY_LEFT: [37, 21], // 左键
    KEY_UP: [38, 19],    // 上键
    KEY_RIGHT: [39, 22], // 右键
    KEY_DOWN: [40, 20],  // 下键
    KEY_ENTER: [13, 23]  // 确认键
  }
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
